import Alert from 'helpers/Alert';
import {useGetNaturalComparator} from 'hooks/useGetNaturalComparator';
import {SWRKeyEnum} from 'interfaces';
import {type MutableRefObject, useCallback} from 'react';
import backendCommunicator from 'services/backendCommunicator';
import useSWR from 'swr';

const useGetNonEmptyCages = ({
  siteId,
  date,
  isMounted,
}: {
  siteId?: string;
  date: Date | null;
  isMounted: MutableRefObject<boolean>;
}) => {
  const naturalComparator = useGetNaturalComparator();
  const fetchNonEmptyCages = useCallback(
    async ([siteId, date]: [siteId: string, date: Date]) => {
      try {
        const response = await backendCommunicator.getNonEmptyCages(siteId, date);
        const data = response.data;
        return data.sort((a, b) => naturalComparator(a.name, b.name));
      } catch (error) {
        isMounted.current && Alert.error(error);
      }
    },
    [naturalComparator, isMounted],
  );

  const {data, error} = useSWR(siteId ? [siteId, date, SWRKeyEnum.GET_SITE_NONEMPTY_CAGES] : null, fetchNonEmptyCages);

  return {
    nonEmptyCages: data,
    isLoading: !!siteId && !error && !data,
  };
};

export default useGetNonEmptyCages;
